import { cn } from "@/lib/cn";

export interface PaginationDotsProps {
  total: number;
  current: number;
  labels?: readonly string[];
  onSelect: (index: number) => void;
  className?: string;
}

export const PaginationDots = ({
  total,
  current,
  labels,
  onSelect,
  className,
}: PaginationDotsProps) => (
  <div className={cn("flex flex-col items-center gap-3", className)}>
    <div className="flex items-center gap-2">
      {Array.from({ length: total }, (_, position) => `page-dot-${position}`).map(
        (dotKey, position) => (
          <button
            key={dotKey}
            type="button"
            onClick={() => onSelect(position)}
            className={cn(
              "size-2 cursor-pointer rounded-full transition-all duration-300",
              position === current
                ? "scale-125 bg-neutral-200/80"
                : "bg-neutral-200/22 hover:bg-neutral-200/40"
            )}
          />
        )
      )}
    </div>
    {labels && (
      <span className="fs-300 font-semibold text-neutral-200/50 transition-opacity duration-300">
        {labels[current]}
      </span>
    )}
  </div>
);
